<template>
  <div class="five-years-durability" :key="refreshKey" data-position="1" data-name="持久流畅">
    <template v-if="isPC">
      <p class="title ffm600">5年持久如新</p>
      <PlusImage
        class="certificate"
        :src="FIVE_YEARS_DURABILITY.certificate"
        alt=""
      />
      <p class="subtitle ffm600">用久了都流畅</p>
      <p class="content">
        蓝河流畅引擎加持的OriginOS 6<br />获得了泰尔实验室和SGS两大权威机构的持久流畅证书。
      </p>
      <PlusImage class="earth" :src="FIVE_YEARS_DURABILITY.earth" alt="" />
      <PlusImage class="light" :src="FIVE_YEARS_DURABILITY.light" alt="" />
    </template>
    <template v-else>
      <PlusImage
        v-if="isPad"
        class="fyd-bg"
        :src="FIVE_YEARS_DURABILITY.padBg"
        alt=""
        v-animate
      />
      <PlusImage v-else class="fyd-bg" :src="FIVE_YEARS_DURABILITY.h5Bg" alt=""  v-animate />
      <p class="subtitle ffm600" v-animate>用久了都流畅</p>
      <p class="content" v-animate>
        蓝河流畅引擎加持的OriginOS 6<br />获得了泰尔实验室和SGS两大权威机构的持久流畅证书。
      </p>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FIVE_YEARS_DURABILITY } from "@/config/image.js";
import { initExposureTrack } from "@/utils/track.js";
import { gsap, ScrollTrigger } from "@/utils/gsapConfig";

export default {
  name: "FiveYearsDurability",
  data() {
    return {
      FIVE_YEARS_DURABILITY,
      refreshKey: 1
    };
  },
  computed: {
    ...mapGetters(["isMobile", "isPad", "isPC"]),
  },
  mounted() {
    initExposureTrack('.five-years-durability')()
    if (this.isPC) {
      this.initGsap();
    }
    let lastWidth = window.innerWidth;
    this.resizeHandler = () => {
      if (this.isPC) {
        if (Math.abs(window.innerWidth - lastWidth) > 10) {
          lastWidth = window.innerWidth;
          if (this.lightTrigger) {
            this.lightTrigger.kill();
          }
          this.refreshKey++
          this.$nextTick(()=>{
            this.initGsap();
          })
        }
      }
    };
    window.addEventListener("resize", this.resizeHandler);
  },
  methods: {
    initGsap() {
      const tl = gsap.timeline();
      tl.fromTo(".light", { opacity: 0.05 }, { opacity: 1 })
        .from(
          ".five-years-durability .title",
          {
            opacity: 0.1,
          },
          "<"
        )
        .fromTo(
          ".five-years-durability .certificate",
          { filter: "brightness(0.1)" },
          { filter: "brightness(1)" },
          "<20%"
        );
      this.lightTrigger = ScrollTrigger.create({
        trigger: ".five-years-durability",
        start: "60% bottom",
        end: "bottom bottom",
        anticipatePin: 1, // 在定格前预先触发的距离
        scrub: true, // 使得元素滚动时，滚动速度等于页面滚动速度
        animation: tl,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.five-years-durability {
  width: 100%;
  height: 1020 * $px1920vw + vw;
  background: #000;
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: -1px;
  & > * {
    position: absolute;
  }
  .earth {
    width: 100%;
    height: 900 * $px1920vw + vw;
    bottom: 0;
    z-index: 2;
  }
  .light {
    width: 1794 * $px1920vw + vw;
    height: 624 * $px1920vw + vw;
    top: 8.5vw;
  }
  .certificate {
    width: 446.61 * $px1920vw + vw;
    height: auto;
    top: 410 * $px1920vw + vw;
    z-index: 3;
  }
  .title {
    width: 1000 * $px1920vw + vw;
    font-size: 160 * $px1920vw + vw;
    line-height: 160 * $px1920vw + vw;
    letter-spacing: 0.1em;
    background: radial-gradient(
      65% 101% at 49% 113%,
      rgba(255, 255, 255, 0) 5%,
      #e5edff 100%
    );
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
    background-clip: text !important;
    text-fill-color: transparent !important;
    z-index: 3;
    top: 285 * $px1920vw + vw;
  }
  .subtitle {
    font-size: 64 * $px1920vw + vw;
    line-height: 76.8 * $px1920vw + vw;
    color: #ffffff;
    top: 735 * $px1920vw + vw;
    z-index: 3;
  }
  .content {
    font-size: 18 * $px1920vw + vw;
    line-height: 25.2 * $px1920vw + vw;
    color: rgba(255, 255, 255, 0.8);
    bottom: 133 * $px1920vw + vw;
    z-index: 3;
  }
}
.isPad {
  .five-years-durability {
    height: 460 * $px676vw + vw;
    .fyd-bg {
      width: 100%;
      height: 100%;
      top: 0;
    }
    .subtitle {
      font-size: 25 * $px676vw + vw;
      line-height: 23 * $px676vw + vw;
      top: 334 * $px676vw + vw;
      z-index: 2;
    }
    .content {
      font-size: 12 * $px676vw + vw;
      line-height: 16 * $px676vw + vw;
      bottom: 62 * $px676vw + vw;
      z-index: 2;
    }
  }
}
.isMobile {
  .five-years-durability {
    height: 420 * $px360vw + vw;
    .subtitle {
      font-size: 25 * $px360vw + vw;
      line-height: 23 * $px360vw + vw;
      top: 306 * $px360vw + vw;
      z-index: 2;
    }
    .content {
      font-size: 12 * $px360vw + vw;
      line-height: 16 * $px360vw + vw;
      bottom: 34.8 * $px360vw + vw;
      z-index: 2;
    }
  }
}
</style>
